import Vue from 'vue';
import Router from 'vue-router';
import auth from '@/auth/authService';
import store from '@/store/store';
import commonFunc from './common/commonFunction';
import EventBusGlobal, { GlobalEventName } from '@/sys/eventBusGlobal';

Vue.use(Router);

const router = new Router({
	mode: 'history',
	base: process.env.BASE_URL,
	scrollBehavior() {
		return { x: 0, y: 0 };
	},
	routes: [
		{
			path: '',
			component: () => import('./layouts/main/Main.vue'),
			children: [
				{
					path: '/',
					redirect: '/loading',
				},
				{
					path: '/dashboard',
					name: 'dashboard',
					component: () =>
						import(
							/*webpackChunkName:'dashboard'*/
							'./views/dashboard/Dashboard.vue'
						),
					meta: {
						requiresAuth: true,
					},
				},
				// =============================================================================
				// Khai thuế
				// =============================================================================
				{
					path: '/taxdecmanagement',
					name: 'taxdecmanagement',
					component: () =>
						import(
							/*webpackChunkName:'taxdec'*/
							'./views/taxdec/taxDecManagement.vue'
						),
				},
				{
					path: '/taxreturnsubmission',
					name: 'taxreturnsubmission',
					component: () =>
						import(
							/*webpackChunkName:'taxdec'*/
							'./views/taxdec/taxreturnsubmission/TaxReturnSubmission.vue'
						),
					meta: {
						requiresAuth: true,
					},
				},
				{
					path: '/taxregis',
					name: 'taxregis',
					component: () =>
						import(
							/*webpackChunkName:'taxdec'*/ './views/taxdec/taxregis/TaxRegis.vue'
						),
					meta: {
						requiresAuth: true,
					},
				},
				{
					path: '/taxreghaunt',
					name: 'taxreghaunt',
					component: () =>
						import(
							/*webpackChunkName:'taxdec'*/ './views/taxdec/taxregis/TaxRegHaunt.vue'
						),
					meta: {
						requiresAuth: true,
					},
				},
				{
					path: '/taxdeclarationprocedure',
					name: 'taxdeclarationprocedure',
					component: () =>
						import(
							/*webpackChunkName:'taxdec'*/ './views/taxdec/TaxDeclarationProcedure.vue'
						),
					meta: {
						requiresAuth: true,
					},
				},
				// =============================================================================
				// Nộp thuế
				// =============================================================================
				{
					path: '/taxpaymanagement',
					name: 'taxpaymanagement',
					component: () =>
						import(
							/*webpackChunkName:'taxpayment'*/
							'./views/taxpayment/taxPayManagement.vue'
						),
				},
				{
					path: 'taxpaper',
					name: 'taxpaper',
					component: () =>
						import(
							/*webpackChunkName:'taxpayment'*/
							'./views/taxpayment/TaxPaper.vue'
						),
					meta: {
						requiresAuth: true,
					},
				},
				{
					path: 'taxpaymentprocedure',
					name: 'taxpaymentprocedure',
					component: () =>
						import(
							/*webpackChunkName:'taxpayment'*/
							'./views/taxpayment/TaxPaymentProcedure.vue'
						),
					meta: {
						requiresAuth: true,
					},
				},
				// =============================================================================
				// Thông báo
				// =============================================================================
				{
					path: '/notification',
					name: 'notification',
					component: () =>
						import(
							/*webpackChunkName:'notification'*/
							'./views/notification/Notification.vue'
						),
					meta: {
						requiresAuth: true,
					},
				},

				// =============================================================================
				// Báo cáo
				// =============================================================================
				{
					path: '/taxreturnsubmissionispaidlist',
					name: 'taxreturnsubmissionispaidlist',
					component: () =>
						import(
							/*webpackChunkName:'notification'*/
							'./views/reports/TaxReturnSubmissionIsPaidList.vue'
						),
					meta: {
						requiresAuth: true,
					},
				},

				{
					path: '/mustpaytaxamountreport',
					name: 'mustpaytaxamountreport',
					component: () =>
						import(
							/*webpackChunkName:'notification'*/
							'./views/reports/MustPayTaxAmountReport.vue'
						),
					meta: {
						requiresAuth: true,
					},
				},

				// =============================================================================
				// Dịch vụ T-VAN MISA
				// =============================================================================
				{
					path: '/servicetvan',
					name: 'servicetvan',
					component: () =>
						import(
							/*webpackChunkName:'tvan'*/ './views/servicetvan/ServiceTVAN.vue'
						),
					meta: {
						requiresAuth: true,
					},
				},

				// =============================================================================
				// Hệ thống
				// =============================================================================
				// =============================================================================
				// Quản lý người dùng
				// =============================================================================
				{
					path: '/usermanager',
					name: 'usermanager',
					component: () =>
						import(
							/*webpackChunkName:'user'*/
							'./views/usermanager/UserList.vue'
						),
					meta: {
						requiresAuth: true,
					},
				},

				// =============================================================================
				// Thông tin người nộp thuế
				// =============================================================================
				{
					path: '/taxpayerinfo',
					name: 'taxpayerinfo',
					component: () =>
						import(
							/*webpackChunkName:'info'*/ './views/taxpayer/TaxPayerInfo.vue'
						),
					meta: {
						requiresAuth: true,
					},
				},
				// // =============================================================================
				// // Nhật ký truy cập
				// // =============================================================================
				{
					path: '/log',
					name: 'log',
					component: () =>
						import(
							/*webpackChunkName:'info'*/ './views/log/AccessLog.vue'
						),
					meta: {
						requiresAuth: true,
					},
				},
				// // =============================================================================
				// // Chữ ký
				// // =============================================================================
				{
					path: 'connectesign',
					name: 'connectesign',
					component: () =>
						import(
							/*webpackChunkName:'connect'*/ './views/system/ConnectEsign.vue'
						),
					meta: {
						requiresAuth: true,
					},
				},
				// // =============================================================================
				// // Email nhận thông báo
				// // =============================================================================
				{
					path: 'contactadditionallist',
					name: 'contactadditionallist',
					component: () =>
						import(
							/*webpackChunkName:'contact'*/ './views/system/ContactAdditionalList.vue'
						),
					meta: {
						requiresAuth: true,
					},
				},
				// // =============================================================================
				// // Tùy chọn
				// // =============================================================================
				{
					path: 'optionssetings',
					name: 'optionssetings',
					component: () =>
						import(
							/*webpackChunkName:'setting'*/ './views/system/OptionsSettings.vue'
						),
					meta: {
						requiresAuth: true,
					},
				},

				// // =============================================================================
				// // Thiết lập khoản nộp ngân sách nhà nước
				// // =============================================================================
				{
					path: 'statebudget',
					name: 'statebudget',
					component: () =>
						import(
							/*webpackChunkName:'setting'*/ './views/system/statebudget/StateBudget.vue'
						),
					meta: {
						requiresAuth: true,
					},
				},

				// // =============================================================================
				// // Tài nguyên
				// // =============================================================================
				{
					path: 'resources',
					name: 'resources',
					component: () =>
						import(
							/*webpackChunkName:'resources'*/ './views/system/resource/Resources.vue'
						),
					meta: {
						requiresAuth: true,
						amisHide: true,
					},
				},
				// // =============================================================================
				//Mua hàng
				// // =============================================================================
				{
					path: '/order',
					name: 'order',
					redirect: '/order/paymentOrder',

					component: () =>
						import(
							/*webpackChunkName:'order'*/ './views/system/order/Order.vue'
						),
					meta: {
						requiresAuth: true,
					},
					children: [
						{
							path: 'paymentOrder',
							name: 'paymentOrder',
							component: () =>
								import(
									/*webpackChunkName:'order'*/ './views/system/order/paymentOrder.vue'
								),
							meta: {
								requiresAuth: true,
							},
						},
						{
							path: 'orderResult',
							name: 'orderResult',
							component: () =>
								import(
									/*webpackChunkName:'order'*/ './views/system/order/OrderResult.vue'
								),
							meta: {
								requiresAuth: true,
							},
						},
					],
				},
			],
			meta: {
				requiresAuth: true,
			},
		},
		{
			path: '/startedregister',
			name: 'startedregister',
			component: () =>
				import(
					/*webpackChunkName:'started'*/
					'./views/started/StartedRegister.vue'
				),
			meta: {
				requiresAuth: true,
			},
		},
		// =============================================================================
		// Màn loading trung gian: exchangeSession (amis) + check quyền + redirect
		// Alias /amis-callback: callback được AMIS Platform điều hướng sau khi đăng nhập
		// =============================================================================
		{
			path: '/loading',
			alias: '/amis-callback',
			name: 'loadingAuth',
			component: () =>
				import(
					/*webpackChunkName:'started'*/
					'./views/started/LoadingAuth.vue'
				),
			meta: {
				requiresAuth: false,
			},
		},
		/**
		 * router trang chủ
		 * - Bổ sung để kiểm tra quyền phân hệ được phép truy cập
		 */
		{
			path: '/home',
			name: 'pageHome',
			component: () => import('@/pages/Home.vue'),
		},
		{
			path: '/login',
			name: 'login',
			redirect: '/login/loginmisaid',
			component: () =>
				import(/*webpackChunkName:'login'*/ '@/views/login/Login.vue'),
			meta: {
				requiresAuth: false,
			},
			children: [
				{
					path: 'loginmisaid',
					name: 'loginmisaid',
					component: () =>
						import(
							/*webpackChunkName:'login'*/
							'@/views/login/LoginMisaID.vue'
						),
					meta: {
						requiresAuth: false,
						loginForm: true,
					},
				},
				{
					path: 'confirm',
					name: 'confirm',
					component: () =>
						import(
							/*webpackChunkName:'login'*/
							'@/views/login/Confirm.vue'
						),
					meta: {
						requiresAuth: false,
					},
				},
				{
					path: 'enterpassword',
					name: 'enterpassword',
					component: () =>
						import(
							/*webpackChunkName:'login'*/
							'@/views/login/EnterPassword.vue'
						),
					meta: {
						requiresAuth: false,
					},
				},
				{
					path: 'forgotpassword',
					name: 'forgotpassword',
					component: () =>
						import(
							/*webpackChunkName:'login'*/
							'@/views/login/ForgotPassword.vue'
						),
					meta: {
						requiresAuth: false,
					},
				},
				{
					path: 'forgotconfirm',
					name: 'forgotconfirm',
					component: () =>
						import(
							/*webpackChunkName:'login'*/
							'@/views/login/ForgotConfirm.vue'
						),
					meta: {
						requiresAuth: false,
					},
				},
				{
					path: 'resetpassword',
					name: 'resetpassword',
					component: () =>
						import(
							/*webpackChunkName:'login'*/
							'@/views/login/ResetPassword.vue'
						),
					meta: {
						requiresAuth: false,
					},
				},
				{
					path: 'verifytwofactor',
					name: 'verifytwofactor',
					component: () =>
						import(
							/*webpackChunkName:'login'*/
							'@/views/login/VerifyTwoFactor.vue'
						),
					meta: {
						requiresAuth: false,
					},
				},
				{
					path: 'startwithtaxcode',
					name: 'startwithtaxcode',
					component: () =>
						import(
							/*webpackChunkName:'login'*/
							'@/views/login/StartWithTaxCode.vue'
						),
					meta: {
						requiresAuth: true,
					},
				},
			],
		},
		{
			path: '/activestore',
			name: 'activestore',
			component: () =>
				import(
					/*webpackChunkName:'buyer'*/ '@/views/activestore/ActiveStore.vue'
				),
			meta: {
				requiresAuth: false,
			},
		},
		{
			path: '/Payment/PaymentResult',
			name: 'PaymentResult',
			component: () =>
				import(
					/*webpackChunkName:'buyer'*/ '@/pages/paymentResult.vue'
				),
			meta: {
				requiresAuth: false,
			},
		},
		{
			path: '/payment',
			name: 'payment',
			component: () =>
				import(/*webpackChunkName:'buyer'*/ '@/pages/buyer.vue'),
			meta: {
				requiresAuth: false,
			},
		},
		// // =============================================================================
		// // Màn hình phục vụ direct sang các phân hệ, màn hình mong muốn
		// // =============================================================================
		{
			path: '/directPage',
			name: 'directPage',
			component: () => import('@/views/commons/DirectPage.vue'),
			meta: {
				requiresAuth: false,
			},
		},
		// // =============================================================================
		// // Giấy nộp tiền tích hợp các bên
		// // =============================================================================
		{
			path: '/taxPaperInter',
			name: 'taxPaperInter',
			component: () =>
				import('@/views/taxpayment/AddTaxPaperIntegration.vue'),
			meta: {
				requiresAuth: false,
			},
		},
		{
			path: '/pages/error-404',
			name: 'pageError404',
			component: () =>
				import(/*webpackChunkName:'router'*/ '@/pages/Error404.vue'),
			meta: {
				requiresAuth: false,
			},
		},
		{
			path: '/pages/not-permission',
			name: 'notPermission',
			component: () =>
				import(
					/*webpackChunkName:'router'*/
					'@/pages/NotPermission.vue'
				),
			meta: {
				requiresAuth: false,
			},
		},
		{
			path: '/pages/error-500',
			name: 'pageError500',
			component: () =>
				import(/*webpackChunkName:'router'*/ '@/pages/Error500.vue'),
			meta: {
				requiresAuth: false,
			},
		},
		{
			path: '/pages/maintancesystem',
			name: 'maintancesystem',
			component: () =>
				import(
					/*webpackChunkName:'router'*/
					'@/pages/MaintanceSystem.vue'
				),
			meta: {
				requiresAuth: false,
			},
		},
		{
			path: '/pages/notauthorized',
			name: 'notauthorized',
			component: () =>
				import(
					/*webpackChunkName:'router'*/
					'@/pages/NotAuthorized.vue'
				),
			meta: {
				requiresAuth: false,
			},
		},
		// Redirect to 404 page, if no match found
		{
			path: '*',
			redirect: '/pages/error-404',
			meta: {
				requiresAuth: false,
			},
		},
	],
});

let routerOnReady = function () {};

let routerOnError = function (error) {
	commonFunc.errorLogging(error);
};

router.onError((error) => {
	const pattern = /Loading chunk (\S)+ failed/g;
	const isChunkLoadFailed = error.message.match(pattern);
	if (isChunkLoadFailed) {
		// messageBox
		// 	.showError(
		// 		'Phiên bản bạn đang sử dụng là phiên bản cũ. Vui lòng nạp lại trang.'
		// 	)
		// 	.then(res => {
		// 		window.location.reload();
		// 	});
	}
});

router.onReady(routerOnReady, routerOnError);

router.afterEach(() => {
	commonFunc.unmask();
});

router.beforeEach(async (to, from, next) => {
	//Không cần check xác thực với những màn đã cấu hình trong router
	EventBusGlobal.$emit(GlobalEventName.closeAllPopup);

	//Kiểm tra xem có đang bảo trì hệ thống hay không?
	if (
		to.name != 'maintancesystem' &&
		window.__env.AppConfig.IsMantainceSystem
	) {
		return next('/pages/maintancesystem');
	} else if (
		to.name == 'maintancesystem' &&
		!window.__env.AppConfig.IsMantainceSystem
	) {
		return next('/');
	}

	//Có yêu cầu đăng nhập hay không
	if (!to.meta.requiresAuth) {
		//Nếu đã đăng nhập thì cho vào ứng dụng luôn
		if (auth.isAuthenticated() && to.name == 'loginmisaid') {
			return next('/');
		} else {
			return next();
		}
	} else {
		//Kiểm tra xem đã xác thực hay chưa?
		if (auth.isAuthenticated()) {
			const isIndividual =
				store.getters['taxpayerinfo/isIndividualTaxpayer'];
			const skipTVan = store.getters['config/IsRulesForIndividual'];
			//Nếu là HKD và config ẩn tab quy trình ở khai thế và nộp thuế
			if (isIndividual && skipTVan) {
				if (to.name === 'taxdeclarationprocedure') {
					return next('/taxreturnsubmission');
				}

				if (to.name === 'taxpaymentprocedure') {
					return next('/taxpaper');
				}
			}

			//Ẩn route khi lên AMIS
			if (to.meta.amisHide && window.__env.siteConfig.isAmisApp) {
				return next('/');
			}
			
			return next();
		} else {
			if (window.__env.siteConfig.isAmisApp) {
				window.location.href = '/';
			} else {
				//Chưa xác thực bắt vào login
				return next('/login/loginmisaid');
			}
		}
	}
});

export default router;
